import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import ReportAssessment from '../report/Assessment/ReportAssessment';
import AssessmentCreateFromTemplate from '../report/AssessmentCreateFromTemplate';
import { CREATE_FROM_TEMPLATE_PATH } from '../report/AssessmentCreateFromTemplate/createFromTemplateConfig';
import TaskRealm from '../task/TaskRealm/TaskRealm';
import TaskDetail from '../task/TaskDetail';
import NavBar from './NavBar';
import Home from './Home';
import Changelog from './Changelog';
import { PerformAgentPage, PerformEditionPage, PerformLibraryPage, PerformTasksPage, PerformReportsPage, PerformCoursesPage, PerformCourseEditionsPage } from './Content';
import AccessAlertSnack from 'global/components/AccessAlertSnack';
import { shouldUnmountNativeOwnedReports } from 'global/utils/nativeShell';

const unlessNativeOwned = (renderPage) => (match) => {
  if (shouldUnmountNativeOwnedReports(match.location.pathname)) return null;
  return renderPage(match);
};

export default withRouter((props) => {
  return (
    <>
      <NavBar hide={props.hide} changeRealm={props.changeRealm} realm={props.realm} pageTitle={props.title} pageValue={props.match.params.base || false} />
      <AccessAlertSnack />
      <Switch>
        <Route exact path="/home" render={(match) => <Home realm={props.realm} changeTitle={props.changeTitle} {...match} />} />
        <Route exact path="/library" render={(match) => <PerformEditionPage realm={props.realm} changeTitle={props.changeTitle} requiredNav={'library'} {...match} />} />
        <Route path="/library/:library" render={(match) => <PerformLibraryPage realm={props.realm} requiredNav={'library'} changeTitle={props.changeTitle} {...match} />} />
        <Route exact path="/courses" render={(match) => <PerformCoursesPage realm={props.realm} changeTitle={props.changeTitle} requiredNav={'library'} {...match} />} />
        <Route path="/courses/:id" render={(match) => <PerformCourseEditionsPage realm={props.realm} requiredNav={'library'} changeTitle={props.changeTitle} {...match} />} />
        <Route path="/tasks/list/:id" render={(match) => <TaskRealm realm={props.realm} requiredNav={'tasks'} onRealmChange={() => props.history.push('/tasks/list')} {...match} />} />
        <Route path="/tasks/detail/:id" render={(match) => <TaskDetail {...match} requiredNav={'tasks'} />} />
        <Route exact path="/tasks" render={(match) => <PerformTasksPage realm={props.realm} requiredNav={'tasks'} changeTitle={props.changeTitle} {...match} />} />
        <Route exact path="/tasks/:display" render={(match) => <PerformTasksPage realm={props.realm} requiredNav={'tasks'} changeTitle={props.changeTitle} {...match} />} />
        <Route exact path="/tasks/:display/:realmid" render={(match) => <PerformTasksPage realm={props.realm} requiredNav={'tasks'} changeTitle={props.changeTitle} {...match} />} />
        {/* PFM-2545: static create-from-template link. Registered before the
            broad /reports/:display + /reports/assessment* routes; the 3-segment
            path won't collide with the `exact` 2-segment /reports/:display. */}
        <Route exact path={CREATE_FROM_TEMPLATE_PATH} render={(match) => <AssessmentCreateFromTemplate realm={props.realm} {...match} />} />
        <Route
          exact
          path="/reports"
          render={unlessNativeOwned((match) => (
            <PerformReportsPage realm={props.realm} requiredNav={'assessments'} changeTitle={props.changeTitle} {...match} />
          ))}
        />
        <Route
          exact
          path="/reports/:display"
          render={unlessNativeOwned((match) => (
            <PerformReportsPage realm={props.realm} requiredNav={'assessments'} changeTitle={props.changeTitle} {...match} />
          ))}
        />
        <Route exact path="/agent" render={(match) => <PerformAgentPage realm={props.realm} changeTitle={props.changeTitle} requiredNav={'agent'} allowedPermissions={['accessAgent']} {...match} />} />
        <Route
          path="/reports/assessment/:id"
          render={unlessNativeOwned((match) => (
            <ReportAssessment realm={props.realm} requiredNav={'assessments'} onRealmChange={() => props.history.push('/reports/list')} {...match} />
          ))}
        />
        <Route
          path="/reports/assessment-template/:id"
          render={(match) => <ReportAssessment isTemplate={true} realm={props.realm} requiredNav={'assessments'} onRealmChange={() => props.history.push('/reports/list')} {...match} />}
        />
        <Route path="/changelog" render={(match) => <Changelog changeTitle={props.changeTitle} {...match} />} />
      </Switch>
    </>
  );
});
